import jsDig from "utils/jsDig.js";

export default (service, section, metric, dashboards, enabledServices) => {
  // This could be expanded if we ever need more customized metrics
  if (service == "ppc") {
    const services = ["search", "social", "display", "video"].filter((serviceName) => enabledServices[serviceName] == true);
    let canBuild = false;

    if (metric.includes("shopify")) {
      canBuild = true;
    }

    if (section == "campaignGroups" || section == "performanceByChannel") {
      canBuild = true;
    }

    if (section == "goalsAndProjections" || section == "allKpisVsPreviousYear") {
      services.forEach((serviceName) => {
        const dbOrd = jsDig([serviceName], dashboards);
        const subGroupSections = dbOrd.filter((s) => (s["enabled"] == true) && s["name"] == "goalsAndProjections" || s["name"] == "allKpisVsPreviousYear");
        subGroupSections.forEach((subGroupSection) => {
          if (jsDig(["metrics_data", metric], subGroupSection) == "1") {
            canBuild = true;
          }
        })
      })
    }

    if (section == "primaryKpiCharts") {
      services.forEach((serviceName) => {
        const dbOrd = jsDig([serviceName], dashboards);
        const subGroupSections = dbOrd.filter((s) => (s["enabled"] == true) && s["name"] == "primaryKpiCharts");
        subGroupSections.forEach((subGroupSection) => {
          if (jsDig(["metrics_data", metric], subGroupSection) == "1") {
            canBuild = true;
          }
        })
      })
    }

    if (section == "primaryKpiTables") {
      services.forEach((serviceName) => {
        const dbOrd = jsDig([serviceName], dashboards);
        const subGroupSections = dbOrd.filter((s) => (s["enabled"] == true) && s["name"] == "primaryKpiTables");
        subGroupSections.forEach((subGroupSection) => {
          if (jsDig(["metrics_data", metric], subGroupSection) == "1") {
            canBuild = true;
          }
        })
      })
    }

    if (section == "spendAllocation") {
      services.forEach((serviceName) => {
        const dbOrd = jsDig([serviceName], dashboards);
        const subGroupSections = dbOrd.filter((s) => (s["enabled"] == true) && s["name"] == "spendAllocation");
        subGroupSections.forEach((subGroupSection) => {
          if (jsDig(["metrics_data", metric], subGroupSection) == "1") {
            canBuild = true;
          }
        })
      })
    }

    return canBuild;
  } else {
    return true;
  }
}
